import React, { Component, Fragment } from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
} from "@material-ui/core";
import { reduxForm } from "redux-form";
import { Col, CardBody, Button, Row } from "reactstrap";

import {
  DatePicker,
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import ModalMessage from "../../../../shared/components/Modal";
import Modal from "@material-ui/core/Modal";
import MapAddressSearch from "./MapAddressSearch";
import { number } from "prop-types";

class FormPatient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typeOfDocument: "",
      documentNumber: "",
      id_patient: "",
      id_history: "",
      names: "",
      firstLastName: "",
      secondLastName: "",
      gender: "",
      address: "",
      email: "",
      cellphone: "",
      telephone1: "",
      telephone2: "",
      bloodType: "",
      date: new Date(),
      birthday: new Date(),
      civilStatus: "",
      race: "",
      races: [],
      ethnicity: "",
      ethnicities: [],
      countries: [],
      country: "",
      department: "",
      city: "",
      ocupation: "",
      regime: "",
      regimes: [],
      exist: false,
      update: false,
      errors: {},
      error: false,
      openAlert: false,
      modalAlert: { message: "", color: "", title: "" },
      openAlertDuplicates: false,
      modalAlertDuplicates: { message: "", color: "", title: "" },
      openMap: false,
      departments: [],
      cities: [],
      zone: null,
      vitalState: "VIVO",
      isLoading: true,
      pacientesDuplicados: [],
      documentOriginal: null,
      poblacionVulnerable: "",
      poblaciones:[]
    };
  }

  validateDuplicates = () => {
    const valores = {
      num_documento: this.state.documentOriginal,
      nombres: this.state.names,
      apellido1: this.state.firstLastName,
      apellido2: this.state.secondLastName,
      id_paciente: this.state.id_patient,
    };
    fetch(process.env.REACT_APP_PUBLIC_URL + "paciente/validar-duplicados", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(valores),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        
        // Mostrar notificacion de que hay duplicados
        if (data && !!data.length) {
          this.setState({ pacientesDuplicados: data });
          this.setState({
            openAlertDuplicates: true,
            modalAlertDuplicates: {
              message: <ValidateDuplicatesMessage arrayDuplicates={data} />,
              color: "warning",
              title: "El paciente ya existe",
            },
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  handleUnirDuplicados = async () => {
    try {
      const {
        id_patient: id_paciente_nuevo,
        id_history: id_historia_nuevo,
        pacientesDuplicados: array_pacientes_duplicados
      } = this.state;
  
      const data = {
        id_paciente_nuevo,
        id_historia_nuevo,
        array_pacientes_duplicados,
      };
  
      const response = await fetch(process.env.REACT_APP_PUBLIC_URL + "paciente/unir-duplicados", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });
  
      const responseData = await response.json();
  
      if (responseData.completed) {
        this.setState({ openAlertDuplicates: false});
  
        this.setState({
          openAlert: true,
          modalAlert: {
            message: "Pacientes unidos con exito",
            color: "success",
            title: "Exitoso!",
          },
        });
      }
    } catch (error) {
      console.error("Error:", error);
    }
    
  }

  handlerDocumentNumber = (number) => {
    let noSpaces = number.trim()
    if(!this.state.documentOriginal){
      this.setState({documentOriginal: noSpaces})
    }
    this.setState({ documentNumber: noSpaces }, () => {
      this.loadDataPatient(noSpaces);
    });
  };

  handlePoblacionVulnerable = (poblacion) => {
    this.setState({ poblacionVulnerable: poblacion });
  };

  handlerTypeOfDocument = (type) => {
    this.setState({ typeOfDocument: type });
  };

  handlerNames = (names) => {
    this.setState({ names: names });
  };

  handlerFirstLastName = (name) => {
    this.setState({ firstLastName: name });
  };

  handlerSecondLastName = (name) => {
    this.setState({ secondLastName: name });
  };

  handlerGender = (gender) => {
    this.setState({ gender: gender });
  };

  handlerBirthDate = (birthday) => {
    this.setState({ birthday: birthday });
  };

  handlerCivilStatus = (status) => {
    this.setState({ civilStatus: status });
  };

  handlerRace = (race) => {
    this.setState({ race: race });
  };

  handlerEthnicity = (ethnicity) => {
    this.setState({ ethnicity: ethnicity });
  };

  handlerCountry = (country) => {
    this.setState({ country: country });
  };

  handlerDepartment = (department) => {
    this.setState({ department: department, city: [] }, () => {
      this.loadCities(department).then((cities) => {
        this.setState({ cities: cities });
      });
    });
  };

  handleCity = (e) => {
    console.log(e);
    this.setState({ city: e });
  };

  handlerCity = (city) => {
    this.setState({ city: city });
  };

  handlerAddress = (address) => {
    this.setState({ address: address });
  };

  handlerZone = (zone) => {
    this.setState({ zone: zone });
  };

  handlerTelephone1 = (telephone) => {
    this.setState({ telephone1: telephone });
  };

  handlerTelephone2 = (telephone) => {
    this.setState({ telephone2: telephone });
  };

  handlerCellphone = (cellphone) => {
    this.setState({ cellphone: cellphone });
  };

  handlerEmail = (email) => {
    this.setState({ email: email });
  };

  handlerRegime = (regime) => {
    this.setState({ regime: regime });
  };

  handlerBloodType = (bloodType) => {
    this.setState({ bloodType: bloodType });
  };

  handlerVitalState = (vitalState) => {
    this.setState({ vitalState: vitalState }, () => {
    });
  };

  componentDidMount = () => {
    this.LoadRaces();
    this.LoadEthnicities();
    this.loadRegimes();
    this.loadCountries();
    this.loadDepartment().then((departments) => {
      this.setState({ departments: departments }, () => {
        //console.log(departments);
        /*this.loadDataProfile().then((profile)=> {
                    this.setState({ department: { value: this.state.departments.filter((department)=>{ return department.id ==  profile[0].direccion.id_dpto})[0].depcod, label: this.state.departments.filter((department)=>{ return department.id ==  profile[0].direccion.id_dpto})[0].depnom, id: this.state.departments.filter((department)=>{ return department.id ==  profile[0].direccion.id_dpto})[0].id } }, ()=> {
                        this.loadCities(this.state.department.value).then((cities) => {
                            this.setState({cities: cities}, () =>{

                            })
                        })
                    })
                })*/
      });
    });
    if (this.props.onUpdate) {
      this.setState({ update: true }, () =>
        this.handlerDocumentNumber(this.props.patientToUpdat.num)
      );
    }
    this.loadPoblacionVulnerable();
  };

  loadPoblacionVulnerable = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "poblacion-vulnerable/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({ poblaciones: data });
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadClientAndActivity = () => {
    fetch(process.env.REACT_APP_PUBLIC_URL + "serter/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ serter: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadDataPatient = (num) => {
    let data = { num_documento: num };
    fetch(process.env.REACT_APP_PUBLIC_URL + "paciente/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.existe) {
          this.loadCities(data.contenido[0].direccion.id_departamento).then(
            (cities) => {
              this.setState({ cities: cities }, () => {
                this.setState({
                  typeOfDocument: data.contenido[0].tip_documento,
                  //documentNumber: data.contenido[0].num_documento,
                  date: data.contenido[0].fec_ingreso,
                  id_history: data.contenido[0].id_historia,
                  id_patient: data.contenido[0].id_paciente,
                  names: data.contenido[0].nombres,
                  firstLastName: data.contenido[0].apellido1,
                  secondLastName: data.contenido[0].apellido2,
                  gender: data.contenido[0].sexo,
                  country: data.contenido[0].direccion.id_pais,
                  address: data.contenido[0].direccion.direccion,
                  department: data.contenido[0].direccion.id_departamento,
                  city: data.contenido[0].direccion.id_ciudad,
                  email: data.contenido[0].correo,
                  cellphone: data.contenido[0].celular,
                  telephone1: data.contenido[0].telefono1,
                  telephone2: data.contenido[0].telefono2,
                  bloodType: data.contenido[0].tipo_sangre,
                  birthday: data.contenido[0].fec_nacimiento,
                  civilStatus: data.contenido[0].e_civil,
                  ethnicity: data.contenido[0].id_etnia,
                  race: data.contenido[0].id_raza,
                  regime: data.contenido[0].id_regimen,
                  vitalState: data.contenido[0].estado_vital,
                  ocupation: data.contenido[0].ocupacion,
                  poblacionVulnerable: data.contenido[0].id_poblacion_vulnerable,
                  zone: data.contenido[0].zona,
                  exist: this.state.isLoading ? false : true,
                  update: false,
                });
              });
              this.setState({ isLoading: false });
            }
          );

        } else {
          this.setState({
            /*id_patient: '',
                        names: '',
                        firstLastName: '',
                        secondLastName: '',
                        gender: '',
                        address: '',
                        email: '',
                        cellphone: '',
                        telephone1: '',
                        telephone2: '', 
                        zone: null,
                        birthday: new Date(), */
            exist: false,
            update: false,
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadPlans = (tercero) => {
    var data = { id: tercero.id_tercero };
    fetch(process.env.REACT_APP_PUBLIC_URL + "plan/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.existe) {
          this.setState({
            plans: data.contenido,
            activities: [],
            activity: {},
          });
        } else {
          this.setState({ plans: [], plan: {}, activities: [], activity: {} });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadActivities = (tercero, plan) => {
    var data = { id_tercero: tercero.id_tercero, id_plan: plan.id_plan };
    fetch(process.env.REACT_APP_PUBLIC_URL + "serter/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.existe) {
          this.setState({ activities: data.contenido[0].servicios.servicios });
        } else {
          this.setState({ activities: [], activity: {} });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  LoadEthnicities = () => {
    fetch(process.env.REACT_APP_PUBLIC_URL + "etnia/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ ethnicities: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  LoadRaces = () => {
    fetch(process.env.REACT_APP_PUBLIC_URL + "raza/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ races: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadRegimes = () => {
    fetch(process.env.REACT_APP_PUBLIC_URL + "regimen/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ regimes: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadCountries = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "paises/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ countries: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadDepartment = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "departamentos/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  loadCities = (depcod) => {
    var data = { id_dpto: depcod };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "ciudades/listar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  validateData = () => {
    var errors = this.state.errors;
    var error = false;

    if (this.state.typeOfDocument === "") {
      errors.typeOfDocument = "Seleccione un tipo de documento";
      error = true;
    } else {
      errors.typeOfDocument = "";
    }

    if (this.state.documentNumber === "") {
      errors.documentNumber = "Ingrese un número de documento";
      error = true;
    } else {
      errors.documentNumber = "";
    }

    if (this.state.names === "") {
      errors.names = "Ingrese al menos un nombre";
      error = true;
    } else {
      errors.names = "";
    }

    if (this.state.firstLastName === "") {
      errors.firstLastName = "Ingrese apellido";
      error = true;
    } else {
      errors.firstLastName = "";
    }

    /* if (this.state.secondLastName === "") {
            errors.secondLastName = "Ingrese apellido";
            error = true;
        } else {
            errors.secondLastName = "";
        } */

    if (this.state.gender === "") {
      errors.gender = "Seleccione un genero";
      error = true;
    } else {
      errors.gender = "";
    }

    if (
      moment(this.state.birthday).format("YYYY/MM/DD") ===
      moment(new Date()).format("YYYY/MM/DD")
    ) {
      errors.birthday = "Seleccione una fecha";
      error = true;
    } else {
      errors.birthday = "";
    }

    if (this.state.country === "") {
      errors.country = "Seleccione un país";
      error = true;
    } else {
      errors.country = "";
    }

    if (this.state.department === "") {
      errors.department = "Seleccione un departamento";
      error = true;
    } else {
      errors.department = "";
    }

    if (this.state.city === "") {
      errors.city = "Seleccione una ciudad";
      error = true;
    } else {
      errors.city = "";
    }

    if (this.state.address === "") {
      errors.address = "Ingrese una dirección";
      error = true;
    } else if (!this.state.address.match(/^[a-zA-Z0-9\s]+$/)) {
      errors.address = "Ingrese una dirección sin caracteres especiales";
      error = true;
    } else {
      errors.address = "";
    }

    /* if (this.state.telephone1 === "") {
            errors.telephone1 = "Ingrese una telefono";
            error = true;
        } else {
            errors.telephone1 = "";
        } */

    if (this.state.cellphone === "") {
      errors.cellphone = "Ingrese un celular";
      error = true;
    } else {
      errors.cellphone = "";
    }

    if (this.state.email === "") {
      errors.email = "Ingrese un email";
      error = true;
    } else {
      errors.email = "";
    }

    if (this.state.civilStatus === "") {
      errors.civilStatus = "Seleccione un estado civil";
      error = true;
    } else {
      errors.civilStatus = "";
    }

    /* if (this.state.race === "") {
            errors.race = "Seleccione un raza";
            error = true;
        } else {
            errors.race = "";
        }

        if (this.state.ethnicity === "") {
            errors.ethnicity = "Seleccione etnia";
            error = true;
        } else {
            errors.ethnicity = "";
        } */

    /* if (this.state.ocupation === "") {
            errors.ocupation = "Escriba la Ocupacion";
            error = true;
        } else {
            errors.ocupation = "";
        } */

    if (this.state.bloodType === "") {
      errors.bloodType = "Seleccione tipo de sangre";
      error = true;
    } else {
      errors.bloodType = "";
    }

    if (this.state.vitalState === "") {
      errors.vitalState = "Seleccione un estado vital";
      error = true;
    } else {
      errors.vitalState = "";
    }

     if (this.state.poblacionVulnerable === "" || this.state.poblacionVulnerable === null) {
      errors.poblacionVulnerable = "Seleccione una población vulnerable";
      error = true;
    } else {
      errors.poblacionVulnerable = "";
    }

    if (
      this.state.zone === "" ||
      this.state.zone == null ||
      this.state.zone == undefined
    ) {
      errors.zone = "Seleccione una Zona";
      error = true;
    } else {
      errors.zone = "";
    }

    if (error) {
      console.log("Error datos incorrectos");
      this.setState({
        openAlert: true,
        modalAlert: {
          message: "No se pudo guardar el paciente",
          color: "warning",
          title: "Error!",
        },
      });
    } else {
      if (this.props.onUpdate) {
        //update data patient
        this.updatePatient();
      } else {
        //send new patient
        this.createPatient();
      }
    }

    this.setState({ errors: errors, error: error });
  };

  createPatient = () => {
    var data = {
      tipDoc: this.state.typeOfDocument,
      numDoc: this.state.documentNumber,
      ape1: this.state.firstLastName,
      ape2: this.state.secondLastName,
      nombres: this.state.names,
      sexo: this.state.gender,
      fec_nacimiento: this.state.birthday,
      ocupacion: this.state.ocupation,
      direccion: {
        id_pais: this.state.country,
        id_departamento: this.state.department,
        departamento: !isNaN(this.state.department)
          ? this.state.departments.filter(
              (department) => department.depcod === this.state.department
            )[0].depnom
          : "",
        ciudad: !isNaN(this.state.city)
          ? this.state.cities.filter(
              (city) => city.ciucod === this.state.city
            )[0].ciunom
          : "",
        id_ciudad: this.state.city,
        direccion: this.state.address,
      },
      telefono1: this.state.telephone1,
      telefono2: this.state.telephone2,
      celular: this.state.cellphone,
      correo: this.state.email,
      e_civil: this.state.civilStatus,
      id_etnia: this.state.ethnicity,
      id_raza: this.state.race,
      id_regimen: this.state.regime,
      tipo_sangre: this.state.bloodType,
      fecha: moment(new Date()).format("YYYY-MM-DD"),
      zona: this.state.zone,
      estado_vital: this.state.vitalState,
    };
    console.log("CREATEPATIENT", data);
    console.log(
      this.state.cities.filter((city) => city.ciucod === this.state.city)[0]
        .ciunom
    );
    console.log(
      this.state.cities.filter((city) => city.ciucod === this.state.city)
    );
    fetch(process.env.REACT_APP_PUBLIC_URL + "paciente/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.text();
        } else {
          throw new Error("Error guardando los datos");
        }
      })
      .then((data) => {
        this.setState(
          {
            openAlert: true,
            modalAlert: {
              message: data,
              color: "success",
              title: "Exitoso!",
            },
          },
          () => {
            this.setState({
              id_patient: "",
              names: "",
              firstLastName: "",
              secondLastName: "",
              gender: "",
              address: "",
              email: "",
              cellphone: "",
              telephone1: "",
              telephone2: "",
              birthday: new Date(),
              civilStatus: "",
              race: "",
              ethnicity: "",
              country: "",
              department: "",
              city: "",
              bloodType: "",
              regime: "",
              typeOfDocument: "",
              documentNumber: "",
              vitalState: "",
              zone: null,
              exist: false,
              update: false,
            });
            this.props.setOpenModalCreatePatient(false);
          }
        );
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({
          openAlert: true,
          modalAlert: {
            message: error.message,
            color: "danger",
            title: "No se pudo crear este paciente",
          },
        });
      });
  };

  updatePatient = () => {
    var data = {
      tipo_documento: this.state.typeOfDocument,
      id_paciente: this.state.id_patient,
      id_historia: this.state.id_history,
      num_documento: this.state.documentNumber,
      ape1: this.state.firstLastName,
      ape2: this.state.secondLastName,
      nombres: this.state.names,
      sexo: this.state.gender,
      fec_nacimiento: this.state.birthday,
      ocupacion: this.state.ocupation,
      direccion: {
        id_pais: this.state.country,
        departamento: !isNaN(this.state.department)
          ? this.state.departments.filter(
              (department) => department.depcod === this.state.department
            )[0].depnom
          : "",
        id_departamento: this.state.department,
        ciudad: !isNaN(this.state.city)
          ? this.state.cities.filter(
              (city) => city.ciucod === this.state.city
            )[0].ciunom
          : "",
        id_ciudad: this.state.city,
        direccion: this.state.address,
      },
      telefono1: this.state.telephone1,
      telefono2: this.state.telephone2,
      celular: this.state.cellphone,
      correo: this.state.email,
      e_civil: this.state.civilStatus,
      id_etnia: this.state.ethnicity,
      id_raza: this.state.race,
      id_regimen: this.state.regime,
      tipo_sangre: this.state.bloodType,
      fecha: moment(new Date()).format("YYYY-MM-DD"),
      zona: this.state.zone,
      estado_vital: this.state.vitalState,
      id_poblacion_vulnerable: this.state.poblacionVulnerable, 
      //fec_ingreso: this.state.date
    };

    console.log("PACIENTEACTUALIZAR", data);

    if (this.state.exist) {
      this.setState({
        openAlert: true,
        modalAlert: {
          message: "Desea unificar la información del paciente",
          color: "warning",
          title: "El paciente ya existe",
        },
      });
      return;
    }

    fetch(process.env.REACT_APP_PUBLIC_URL + "paciente/update", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }
    })
      .then(
        (data) => {
          this.setState(
            {
              openAlert: true,
              modalAlert: {
                message: "El paciente se actualizco correctamente",
                color: "success",
                title: "Exitoso!",
              },
            },
            //this.props.setOpenModalCreatePatient(false)
          );
        },
        () => {
          this.setState({
            id_patient: "",
            names: "",
            firstLastName: "",
            secondLastName: "",
            gender: "",
            address: "",
            email: "",
            cellphone: "",
            telephone1: "",
            telephone2: "",
            birthday: new Date(),
            civilStatus: "",
            race: "",
            ethnicity: "",
            country: "",
            department: "",
            city: "",
            bloodType: "",
            regime: "",
            typeOfDocument: "",
            documentNumber: "",
            vitalState: "",
            zone: null,
            exist: false,
            update: false,
          });
        }
      )
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  render() {
    //const { classes } = this.props;
    return (
      <Col>
        <CardBody>
          <Row>
            <Col md={12}>
              <div className="title-general-section-icon-arrow-back">
                {this.props.onUpdate ? (
                  <h3>Actualizar paciente</h3>
                ) : (
                  <h3>Crear paciente</h3>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <div className="subtitle-general">
              <h4 style={{ margin: "0.25em 0em" }}>DATOS BÁSICOS</h4>
            </div>
          </Row>
          <form className="material-form">
            <Row style={{ margin: "0.25em 1em" }}>
              <Col md={3} sm={6} xs={12}>
                <TextField
                  className="material-form__field"
                  label="Tipo  de documento"
                  id="id-simpledoc-select"
                  value={this.state.typeOfDocument}
                  select
                  onChange={(event) => {
                    this.handlerTypeOfDocument(event.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("typeOfDocument")
                      ? this.state.errors.typeOfDocument !== ""
                      : false
                  }
                  helperText={this.state.errors.typeOfDocument}
                >
                  <MenuItem
                    className="material-form__option"
                    key={1}
                    value={"TI"}
                  >
                    TI-Tarjeta de Identidad
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={2}
                    value={"CC"}
                  >
                    CC-Cedula de Ciudadania
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={3}
                    value={"PA"}
                  >
                    PA-Pasaporte
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={4}
                    value={"RC"}
                  >
                    RC-Registro Civil
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={5}
                    value={"CE"}
                  >
                    CE-Cedula de Extranjeria
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={6}
                    value={"MS"}
                  >
                    MS-Menor sin Identificación
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={7}
                    value={"AS"}
                  >
                    AS-Adulto sin Identificación
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={8}
                    value={"SC"}
                  >
                    SC-Salvo Conducto
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={9}
                    value={"CD"}
                  >
                    CD-Carnet Diplomatico
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={10}
                    value={"CN"}
                  >
                    CN-Certificado de Nacido Vivo
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={11}
                    value={"NI"}
                  >
					NI-Número Identificación Tributario NIT
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={12}
                    value={"PE"}
                  >
                    PE-Permiso Especial de Permanencia
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={13}
                    value={"PT"}
                  >
                    PT-Permiso por Protección Temporal
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={14}
                    value={"SI"}
                  >
                    SI-Sin Identificación
                  </MenuItem>
                </TextField>
              </Col>
              <Col md={3} sm={6} xs={12}>
                <TextField
                  required
                  id="document-number-standard-required"
                  label="N° de documento"
                  type="number"
                  className="material-form__field"
                  value={this.state.documentNumber}
                  onChange={(e) => this.handlerDocumentNumber(e.target.value)}
                  onBlur={() => this.validateDuplicates()}
                  error={
                    this.state.errors.hasOwnProperty("documentNumber")
                      ? this.state.errors.documentNumber !== ""
                      : false
                  }
                  helperText={this.state.errors.documentNumber}
                />
              </Col>
              <Col md={3} sm={6} xs={12}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <KeyboardDatePicker
                    disableFuture
                    label="Fecha de Nacimiento"
                    className="material-form__field"
                    value={this.state.birthday}
                    onChange={(date) => {
                      if (date !== null) {
                        if (date._isValid) {
                          this.handlerBirthDate(new Date(date));
                        } else {
                          this.handlerBirthDate(new Date(date._i));
                        }
                      }
                    }}
                    animateYearScrolling
                    format="DD/MM/YYYY"
                    //className={classes.date}
                    error={
                      this.state.errors.hasOwnProperty("birthday")
                        ? this.state.errors.birthday !== ""
                        : false
                    }
                    helperText={this.state.errors.birthday}
                  />
                </MuiPickersUtilsProvider>
              </Col>
              <Col md={3} sm={6} xs={12}>
                <TextField
                  className="material-form__field"
                  label="Genero"
                  id="id-simple-select"
                  value={this.state.gender}
                  select
                  onChange={(event) => {
                    this.handlerGender(event.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("gender")
                      ? this.state.errors.gender !== ""
                      : false
                  }
                  helperText={this.state.errors.gender}
                >
                  <MenuItem
                    className="material-form__option"
                    key={0}
                    value={""}
                  >
                    Ninguno
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={1}
                    value={"Masculino"}
                  >
                    Masculino
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={2}
                    value={"Femenino"}
                  >
                    Femenino
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={3}
                    value={"Binario"}
                  >
                    Binario
                  </MenuItem>
                </TextField>
              </Col>
            </Row>
            <Row style={{ margin: "0.25em 1em" }}>
              <Col md={3} sm={6} xs={12}>
                <TextField
                  required
                  id="first-name-standard-required"
                  label="Nombres"
                  type="text"
                  className="material-form__field"
                  value={this.state.names}
                  onChange={(e) => {
                    this.handlerNames(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("names")
                      ? this.state.errors.names !== ""
                      : false
                  }
                  helperText={this.state.errors.names}
                />
              </Col>
              <Col md={3} sm={6} xs={12}>
                <TextField
                  required
                  id="first-last-name-standard-required"
                  label="Primer apellido"
                  type="text"
                  className="material-form__field"
                  value={this.state.firstLastName}
                  onChange={(e) => {
                    this.handlerFirstLastName(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("firstLastName")
                      ? this.state.errors.firstLastName !== ""
                      : false
                  }
                  helperText={this.state.errors.firstLastName}
                />
              </Col>
              <Col md={3} sm={6} xs={12}>
                <TextField
                  id="second-last-name-standard-required"
                  label="Segundo apellido"
                  type="text"
                  className="material-form__field"
                  value={this.state.secondLastName}
                  onChange={(e) => {
                    this.handlerSecondLastName(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("secondLastName")
                      ? this.state.errors.secondLastName !== ""
                      : false
                  }
                  helperText={this.state.errors.secondLastName}
                />
              </Col>
              <Col md={3} sm={6} xs={12}>
                <TextField
                  id="first-telephone-standard-required"
                  label="Teléfono 1"
                  type="text"
                  className="material-form__field"
                  value={this.state.telephone1}
                  onChange={(e) => {
                    this.handlerTelephone1(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("telephone1")
                      ? this.state.errors.telephone1 !== ""
                      : false
                  }
                  helperText={this.state.errors.telephone1}
                />
              </Col>
            </Row>
            <Row style={{ margin: "0.25em 1em" }}>
              <Col md={3} sm={6} xs={12}>
                {/* <TextField
                                    //className={classes.date}
                                    id="second-telephone-standard-required"
                                    label="Teléfono 2"
                                    type="text"
                                    className="material-form__field"
                                    style={{ width: 200, marginLeft: 20 }}
                                    value={this.state.telephone2}
                                    onChange={(e) => {
                                        this.handlerTelephone2(e.target.value);
                                    }}
                                /> */}
                <TextField
                  required
                  id="cellphone-standard-required"
                  label="Celular"
                  type="text"
                  className="material-form__field"
                  value={this.state.cellphone}
                  onChange={(e) => {
                    this.handlerCellphone(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("cellphone")
                      ? this.state.errors.cellphone !== ""
                      : false
                  }
                  helperText={this.state.errors.cellphone}
                />
              </Col>
              <Col md={3} sm={6} xs={12}>
                <TextField
                  required
                  id="email-standard-required"
                  label="Correo electrónico"
                  type="email"
                  className="material-form__field"
                  value={this.state.email}
                  onChange={(e) => {
                    this.handlerEmail(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("email")
                      ? this.state.errors.email !== ""
                      : false
                  }
                  helperText={this.state.errors.email}
                />
              </Col>
              <Col md={3} sm={6} xs={12}>
                <TextField
                  id="ocupation-standard-required"
                  label="Ocupacion"
                  type="text"
                  className="material-form__field"
                  value={this.state.ocupation}
                  onChange={(e) => {
                    this.setState({ ocupation: e.target.value });
                  }}
                  error={
                    this.state.errors.hasOwnProperty("ocupation")
                      ? this.state.errors.ocupation !== ""
                      : false
                  }
                  helperText={this.state.errors.ocupation}
                />
              </Col>
              <Col md={3} sm={6} xs={12}>
                <TextField
                  className="material-form__field"
                  label="Regimen"
                  id="id-simplereg-select"
                  value={this.state.regime}
                  select
                  onChange={(event) => {
                    this.handlerRegime(event.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("regime")
                      ? this.state.errors.regime !== ""
                      : false
                  }
                  helperText={this.state.errors.regime}
                >
                  <MenuItem
                    className="material-form__option"
                    key={0}
                    value={""}
                  >
                    Ninguna
                  </MenuItem>
                  {this.state.regimes.map((regime) => {
                    return (
                      <MenuItem
                        className="material-form__option"
                        key={regime.id_regimen}
                        value={regime.id_regimen}
                      >
                        {regime.regimen}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Col>
            </Row>

            <div className="subtitle-general">
              <h4 style={{ margin: "0.25em 0em" }}>DATOS DE UBICACIÓN</h4>
            </div>
            <Row style={{ margin: "0.25em 1em" }}>
              <Col md={3} sm={6} xs={12}>
                <TextField
                  className="material-form__field"
                  label="País"
                  id="id-simplepais-select"
                  select
                  value={this.state.country}
                  onChange={(event) => {
                    this.handlerCountry(event.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("country")
                      ? this.state.errors.country !== ""
                      : false
                  }
                  helperText={this.state.errors.country}
                >
                  {this.state.countries.map((country) => {
                    return (
                      <MenuItem
                        className="material-form__option"
                        key={country.paicod}
                        value={country.paicod}
                      >
                        {country.painom}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Col>
              <Col md={3} sm={6} xs={12}>
                {this.state.country === "00038" ? (
                  <Fragment>
                    <TextField
                      className="material-form__field"
                      label="Departamento"
                      id="id-simpledep-select"
                      select
                      value={this.state.department}
                      onChange={(event) => {
                        this.handlerDepartment(event.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("department")
                          ? this.state.errors.department !== ""
                          : false
                      }
                      helperText={this.state.errors.department}
                    >
                      {this.state.departments.map((department) => {
                        return (
                          <MenuItem
                            className="material-form__option"
                            key={department.id}
                            value={department.depcod}
                          >
                            {department.depnom}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Fragment>
                ) : (
                  <Fragment>
                    <TextField
                      required
                      id="state-standard-required"
                      label="Departamento o Estado"
                      type="text"
                      className="material-form__field"
                      value={this.state.department}
                      onChange={(e) => {
                        this.handlerDepartment(e.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("department")
                          ? this.state.errors.department !== ""
                          : false
                      }
                      helperText={this.state.errors.department}
                    />
                  </Fragment>
                )}
              </Col>
              <Col md={3} sm={6} xs={12}>
                {this.state.country === "00038" ? (
                  <Fragment>
                    <TextField
                      className="material-form__field"
                      label="Ciudad"
                      id="id-simplecity-select"
                      select
                      value={this.state.city}
                      onChange={(event) => {
                        this.handlerCity(event.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("city")
                          ? this.state.errors.city !== ""
                          : false
                      }
                      helperText={this.state.errors.city}
                    >
                      {this.state.cities.map((city) => {
                        return (
                          <MenuItem
                            className="material-form__option"
                            key={city.id}
                            value={city.ciucod}
                          >
                            {city.ciunom}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Fragment>
                ) : (
                  <Fragment>
                    <TextField
                      required
                      id="city-standard-required"
                      label="Ciudad"
                      type="text"
                      className="material-form__field"
                      value={this.state.city}
                      onChange={(e) => {
                        this.handlerCity(e.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("city")
                          ? this.state.errors.city !== ""
                          : false
                      }
                      helperText={this.state.errors.city}
                    />
                  </Fragment>
                )}
              </Col>
              <Col md={3} sm={6} xs={12}>
                <TextField
                  required
                  id="address-standard-required"
                  label="Dirección"
                  type="text"
                  className="material-form__field"
                  value={this.state.address}
                  onChange={(e) => {
                    this.handlerAddress(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("address")
                      ? this.state.errors.address !== ""
                      : false
                  }
                  helperText={this.state.errors.address}
                />
              </Col>
            </Row>
            <Row style={{ margin: "0.25em 1em" }}>
              <Col md={3} sm={6} xs={12}>
                <TextField
                  className="material-form__field"
                  label="Zona"
                  id="id-zone-select"
                  select
                  value={this.state.zone}
                  InputLabelProps={{ shrink: true }}
                  onChange={(event) => {
                    this.handlerZone(event.target.value);
                    console.log(event.target);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("zone")
                      ? this.state.errors.zone !== ""
                      : false
                  }
                  helperText={this.state.errors.zone}
                >
                  <MenuItem
                    className="material-form__option"
                    key={1}
                    value={"U"}
                  >
                    URBANA
                  </MenuItem>
                  <MenuItem
                    className="material-form__option"
                    key={2}
                    value={"R"}
                  >
                    RURAL
                  </MenuItem>
                </TextField>
              </Col>
            </Row>

            {this.state.exist ? (
              <div
                style={{ margin: 10, color: "#4ce1b6", fontSize: 15 }}
                variant="contained"
                color="primary"
                onClick={() => {
                  //this.loadDataPatient();
                  this.setState({ exist: !this.state.exist });
                }}
              >
                Ver mas
              </div>
            ) : (
              <div
                style={{ margin: 10, color: "#4ce1b6", fontSize: 15 }}
                onClick={() => {
                  //this.loadDataPatient();
                  this.setState({ exist: !this.state.exist });
                }}
              >
                Ver menos
              </div>
            )}
            {!this.state.exist ? (
              <React.Fragment>
                <div className="subtitle-general">
                  <h4 style={{ margin: "0.25em 0em" }}>DATOS ADICIONALES</h4>
                </div>
                <Row style={{ margin: "0.25em 1em" }}>
                  <Col md={3} sm={6} xs={12}>
                    <TextField
                      className="material-form__field"
                      label="Estado civil"
                      id="id-simplest-select"
                      select
                      value={this.state.civilStatus}
                      onChange={(event) => {
                        this.handlerCivilStatus(event.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("civilStatus")
                          ? this.state.errors.civilStatus !== ""
                          : false
                      }
                      helperText={this.state.errors.civilStatus}
                    >
                      <MenuItem
                        className="material-form__option"
                        key={0}
                        value={""}
                      >
                        Ninguno
                      </MenuItem>
                      <MenuItem
                        className="material-form__option"
                        key={1}
                        value={"Soltero"}
                      >
                        Soltero
                      </MenuItem>
                      <MenuItem
                        className="material-form__option"
                        key={2}
                        value={"Casado"}
                      >
                        Casado
                      </MenuItem>
                      <MenuItem
                        className="material-form__option"
                        key={2}
                        value={"Divorciado"}
                      >
                        Divorciado
                      </MenuItem>
                      <MenuItem
                        className="material-form__option"
                        key={2}
                        value={"Viudo"}
                      >
                        Viudo
                      </MenuItem>
                      <MenuItem
                        className="material-form__option"
                        key={2}
                        value={"Unión Libre"}
                      >
                        Unión Libre
                      </MenuItem>
                    </TextField>
                  </Col>
                  <Col md={3} sm={6} xs={12}>
                    <TextField
                      className="material-form__field"
                      label="Raza"
                      id="id-simplerace-select"
                      select
                      value={this.state.race}
                      onChange={(event) => {
                        this.handlerRace(event.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("race")
                          ? this.state.errors.race !== ""
                          : false
                      }
                      helperText={this.state.errors.race}
                    >
                      <MenuItem
                        className="material-form__option"
                        key={0}
                        value={0}
                      >
                        Ninguna
                      </MenuItem>
                      {this.state.races.map((race) => {
                        return (
                          <MenuItem
                            className="material-form__option"
                            key={race.id_raza}
                            value={race.id_raza}
                          >
                            {race.raza}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Col>
                  <Col md={3} sm={6} xs={12}>
                    <TextField
                      className="material-form__field"
                      label="Etnia"
                      id="id-simpletnie-select"
                      select
                      value={this.state.ethnicity}
                      onChange={(event) => {
                        this.handlerEthnicity(event.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("ethnicity")
                          ? this.state.errors.ethnicity !== ""
                          : false
                      }
                      helperText={this.state.errors.ethnicity}
                    >
                      <MenuItem
                        className="material-form__option"
                        key={0}
                        value={0}
                      >
                        Ninguna
                      </MenuItem>
                      {this.state.ethnicities.map((ethnicity) => {
                        return (
                          <MenuItem
                            className="material-form__option"
                            key={ethnicity.id_etnia}
                            value={ethnicity.id_etnia}
                          >
                            {ethnicity.etnia}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Col>
                  <Col md={3} sm={6} xs={12}>
                    <TextField
                      className="material-form__field"
                      label="Tipo de Sangre"
                      id="id-simpletyoe-select"
                      select
                      value={this.state.bloodType}
                      onChange={(event) => {
                        this.handlerBloodType(event.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("bloodType")
                          ? this.state.errors.bloodType !== ""
                          : false
                      }
                      helperText={this.state.errors.bloodType}
                    >
                      <MenuItem key={0} value={"A+"}>
                        A+
                      </MenuItem>
                      <MenuItem key={1} value={"B+"}>
                        B+
                      </MenuItem>
                      <MenuItem key={2} value={"O+"}>
                        O+
                      </MenuItem>
                      <MenuItem key={3} value={"A-"}>
                        A-
                      </MenuItem>
                      <MenuItem key={4} value={"B-"}>
                        B-
                      </MenuItem>
                      <MenuItem key={4} value={"O-"}>
                        O-
                      </MenuItem>
                      <MenuItem key={5} value={"AB+"}>
                        AB+
                      </MenuItem>
                      <MenuItem key={6} value={"AB-"}>
                        AB-
                      </MenuItem>
                      <MenuItem key={7} value={"SIN DEFINIR"}>
                        SIN DEFINIR
                      </MenuItem>
                    </TextField>
                  </Col>
                </Row>
                <Row style={{ margin: "0.25em 1em" }}>
                  <Col md={3} sm={6} xs={12}>
                    <TextField
                      className="material-form__field"
                      label="Estado Vital"
                      id="id-simpletyoe-select"
                      select
                      value={this.state.vitalState}
                      onChange={(event) => {
                        this.handlerVitalState(event.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("vitalState")
                          ? this.state.errors.vitalState !== ""
                          : false
                      }
                      helperText={this.state.errors.vitalState}
                    >
                      <MenuItem key={0} value={"VIVO"}>
                        VIVO
                      </MenuItem>
                      <MenuItem key={1} value={"MUERTO"}>
                        MUERTO
                      </MenuItem>
                      <MenuItem key={2} value={"DESAPARECIDO"}>
                        DESAPARECIDO
                      </MenuItem>
                    </TextField>
                  </Col>
                  {this.props.onUpdate ? (
                                      <Col md={3} sm={6} xs={12}>
                    <FormControl
                      className="material-form__field"
                      InputLabelProps={{
                        style: { color: "#646777"},
                        shrink: true,
                      }}
                      error={
                        this.state.errors.hasOwnProperty("poblacionVulnerable")
                          ? this.state.errors.poblacionVulnerable !== ""
                          : false
                      }
                    >
                      <InputLabel shrink required id="demo-simple-select-label">
                        Población vulnerable
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="id-simple-select"
                        //defaultValue={null}
                        value={this.state.poblacionVulnerable}
                        //disabled={this.state.disableInput}
                        onChange={(event) => {
                          this.handlePoblacionVulnerable(event.target.value);
                        }}
                        error={
                          this.state.errors.hasOwnProperty(
                            "poblacionVulnerable"
                          )
                            ? this.state.errors.poblacionVulnerable !== ""
                            : false
                        }
                      >
                        {this.state.poblaciones.map((poblacion) => {
                          return (
                            <MenuItem
                              key={poblacion.id_poblacion_vulnerable}
                              value={poblacion.id_poblacion_vulnerable}
                            >
                              {poblacion.nombre}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      <FormHelperText>
                        {this.state.errors.poblacionVulnerable}
                    </FormHelperText>
                    </FormControl>          
                  </Col>
                  ):null}

                </Row>

              </React.Fragment>
            ) : null}

            <Row style={{ margin: "0.25em 1em" }}>
              <Col>
                <Button
                  //className={classes.date}
                  style={{ marginTop: 20 }}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    this.validateData();
                    console.log(this.state.error);
                  }}
                >
                  {this.props.onUpdate ? "Actualizar datos" : "Crear paciente"}
                </Button>
              </Col>
            </Row>
          </form>
          {this.state.openAlert ? (
            <ModalMessage
              color={this.state.modalAlert.color}
              title={this.state.modalAlert.title}
              message={this.state.modalAlert.message}
              modal={this.state.openAlert}
              toggle={() => {
                this.setState({ openAlert: !this.state.openAlert });
              }}
              onOk={() => {
                this.setState({ openAlert: !this.state.openAlert });
              }}
            />
          ) : null}
          {this.state.openAlertDuplicates ? (
            <ModalMessage
              color={this.state.modalAlertDuplicates.color}
              title={this.state.modalAlertDuplicates.title}
              message={this.state.modalAlertDuplicates.message}
              modal={this.state.openAlertDuplicates}
              toggle={() => {
                this.setState({ openAlertDuplicates: !this.state.openAlertDuplicates });
              }}
              onOk={() => {
                this.handleUnirDuplicados();
              }}
            />
          ) : null}
          <Modal
            open={this.state.openMap}
            onClose={(e) => {
              this.setState({ openMap: !this.state.openMap });
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            //style={{zIndex: 1000 }}
          >
            <div
              style={{
                position: "absolute",
                backgroundColor: "white",
                width: "80%",
                height: "80%",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                padding: 20,
              }}
            >
              <MapAddressSearch />
            </div>
          </Modal>
        </CardBody>
      </Col>
    );
  }
}

const ValidateDuplicatesMessage = ({ arrayDuplicates }) => {
  return (
    <div>
      <p>¿Desea unificar la información del paciente?</p>
      <p>Información del paciente:</p>
        {arrayDuplicates.map((patient) => {
          return (
            <p key={patient.id_paciente}>
              {patient.num_documento}: {patient.nombres} {patient.ape1} {patient.ape2}
            </p>
          );
        })}
      <p>
        La información de los pacientes aquí listados se reemplazará por la información del paciente que se muestra en el formulario.
        Al finalizar se eliminarán los pacientes duplicados. Esta acción es irreversible.
      </p>
    </div>
  )
}

export default reduxForm({ form: "create_patient_form" })(FormPatient);
